import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import history from './history';
import Layout from '@/containers/Layout';

const Routes = () => (
  <ConnectedRouter history={history}>
    <Switch>
      <Route path="/" component={Layout} />
    </Switch>
  </ConnectedRouter>
);

export default Routes;
